import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, ActivityIcon, HeartPulseIcon, ZapIcon, ArrowUpCircleIcon, RefreshCwIcon, DropletsIcon, NavigationIcon, PlusCircleIcon, CalendarIcon } from 'lucide-react';
export function BenefitsSection() {
  const benefits = [{
    icon: DropletsIcon,
    title: 'Reduces Inflammation',
    desc: 'Helps decrease swelling and inflammatory markers in targeted tissues.'
  }, {
    icon: ShieldCheckIcon,
    title: 'Relieves Pain',
    desc: 'Provides relief for minor muscle and joint pain without the use of drugs.'
  }, {
    icon: RefreshCwIcon,
    title: 'Tissue Repair & Growth',
    desc: "Supports the body's natural cellular regeneration and tissue repair processes."
  }, {
    icon: HeartPulseIcon,
    title: 'Vascular Activity',
    desc: 'Increases local blood circulation, bringing oxygen and nutrients to the area.'
  }, {
    icon: ZapIcon,
    title: 'Metabolic Activity',
    desc: 'Supports higher metabolic rates and increased ATP production in cells.'
  }, {
    icon: ActivityIcon,
    title: 'Reduces Fibrous Tissue',
    desc: 'May help reduce the formation of scar tissue following tissue damage.'
  }, {
    icon: NavigationIcon,
    title: 'Nerve Function',
    desc: 'Supports healthy nerve function and helps address neuropathy symptoms.'
  }, {
    icon: ArrowUpCircleIcon,
    title: 'Range of Motion',
    desc: 'Helps improve flexibility and mobility in stiff or injured joints.'
  }, {
    icon: PlusCircleIcon,
    title: 'Wound Healing',
    desc: 'Supports the biological processes involved in healing minor wounds.'
  }, {
    icon: ActivityIcon,
    title: 'Injury Recovery',
    desc: 'Accelerates recovery timelines for sports injuries and physical strains.'
  }];
  return <section className="py-20 md:py-28 bg-white" data-id="element-13">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center max-w-3xl mx-auto mb-16" data-id="element-15">
          <h2 className="text-3xl md:text-5xl font-bold text-brand-navy mb-6" data-id="element-16">
            Why Patients Choose Laser Therapy
          </h2>
          <p className="text-lg text-gray-600" data-id="element-17">
            Class IV laser therapy offers a comprehensive approach to healing,
            addressing the root causes of pain and dysfunction rather than just
            masking symptoms.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-16" data-id="element-18">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="bg-brand-gray-light p-6 rounded-xl border border-gray-100 hover:shadow-md transition-shadow duration-300" data-id="element-19">
              <benefit.icon className="w-8 h-8 text-brand-teal mb-4" data-id="element-20" />
              <h3 className="text-lg font-bold text-brand-navy mb-2" data-id="element-21">
                {benefit.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-22">
                {benefit.desc}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="max-w-4xl mx-auto text-center bg-brand-gray-light p-8 rounded-2xl border border-gray-200" data-id="element-23">
          <p className="text-gray-700 font-medium mb-8 text-lg" data-id="element-24">
            While many patients notice improvement early in their treatment
            plan, others may need a series of treatments to experience the full
            cumulative benefits of photobiomodulation.
          </p>
          <button className="px-8 py-4 bg-brand-teal hover:bg-brand-teal-dark text-white rounded-lg font-semibold text-lg transition-all duration-300 inline-flex items-center justify-center gap-2 shadow-lg shadow-brand-teal/25" data-id="element-25">
            <CalendarIcon className="w-5 h-5" data-id="element-26" />
            Schedule Your Assessment
          </button>
        </motion.div>
      </div>
    </section>;
}